var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../../framework/base";
import { EditItem } from "../common/editItem";
import { FileAttachment } from "../common/fileAttachment";
import { CalendarTaskRepetitionType, CalendarTaskState } from "../enums";
import { ModifyUser } from "../user/modifyUser";
var CalendarTaskEditItem = /** @class */ (function (_super) {
    __extends(CalendarTaskEditItem, _super);
    function CalendarTaskEditItem(obj) {
        var _this = _super.call(this, obj) || this;
        _this.parentId = obj && obj.parentId || "";
        _this.companyId = obj && obj.companyId || "";
        _this.categoryId = obj && obj.categoryId || "";
        _this.recordId = obj && obj.recordId || "";
        _this.databaseRecordType = obj === null || obj === void 0 ? void 0 : obj.databaseRecordType;
        _this.state = obj && obj.state || CalendarTaskState.NotStarted;
        _this.title = obj && obj.title || "";
        _this.locationText = obj && obj.locationText || "";
        _this.description = obj && obj.description || "";
        _this.startDate = obj && obj.startDate || 0;
        _this.endDate = obj === null || obj === void 0 ? void 0 : obj.endDate;
        _this.allDay = obj && obj.allDay || false;
        _this.isPrivate = obj && obj.isPrivate || false;
        _this.isRead = obj && obj.isRead || false;
        _this.hasChildren = obj && obj.hasChildren || false;
        _this.remainder = -1;
        if (!Base.isNullOrUndefined(obj === null || obj === void 0 ? void 0 : obj.remainder)) {
            _this.remainder = obj.remainder;
        }
        _this.repetitionIntervalType = obj && obj.repetitionIntervalType || CalendarTaskRepetitionType.NotRepeated;
        _this.repetitionInterval = obj && obj.repetitionInterval || 0;
        _this.repetitionIntervalSub = _this.repetitionIntervalType === CalendarTaskRepetitionType.Weekly
            ? 1000000
            : (_this.repetitionIntervalType === CalendarTaskRepetitionType.Monthly
                ? 1
                : 101);
        if (!Base.isNullOrUndefined(obj === null || obj === void 0 ? void 0 : obj.repetitionIntervalSub)) {
            _this.repetitionIntervalSub = obj.repetitionIntervalSub;
        }
        _this.repetitionEndRepeatCount = obj && obj.repetitionEndRepeatCount || 0;
        _this.repetitionEndDate = obj && obj.repetitionEndDate || 0;
        if (!_this.repetitionEndDate && !_this.repetitionEndRepeatCount && _this.repetitionIntervalType !== CalendarTaskRepetitionType.NotRepeated) {
            _this.repetitionEndRepeatCount = 1;
        }
        _this.createUser = new ModifyUser(obj ? obj.createUser : null);
        _this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        _this.lockedUser = (obj === null || obj === void 0 ? void 0 : obj.lockedUser) ? new ModifyUser(obj.lockedUser) : null;
        _this.handlers = Base.getTypedArray(obj ? obj.handlers : null, ModifyUser);
        _this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
        return _this;
    }
    CalendarTaskEditItem.prototype.isLockedToOtherUser = function (userCode) {
        var _a;
        return ((_a = this.lockedUser) === null || _a === void 0 ? void 0 : _a.code) && !userCode.equalIgnoreCase(this.lockedUser.code);
    };
    return CalendarTaskEditItem;
}(EditItem));
export { CalendarTaskEditItem };
